import axios from 'axios';
import { API } from '../_constant';

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/**
 * Call API ajax
 * api.url
 * api.req
 * api.id
 * API[api.url].test true-測試 使用假資料
 * baseURL 若有值，使用此網域
 */
 export const PostData = (api, callback, baseURL) => {

  const DOMAIN = window.location.hostname;
  console.log('DOMAIN', DOMAIN);

  if(DOMAIN === 'localhost' || API[api.url].test){

    const protocol = DOMAIN === 'localhost' ? 'http' : 'https';
    let folder = '';
    if(API[api.url].folder) {
      folder = `${API[api.url].folder}/`;
    }
    const _URL = `${protocol}://${window.location.host}${global.path}/json/localhost/${folder}${api.url}.json`;

    console.log('↓↓================');
    console.log(`%ccall api localhost [${api.url}] localhost`, 'color: #3faaf4; font-weight: bold;');
    console.log('method：', API[api.url].method);
    console.log('folder', API[api.url].folder);
    console.log('url：', _URL);
    console.log('req：', api.req);
    console.log('id：', api.id);
    console.log('test：', API[api.url].test);
    console.log('↑↑================');

    LoadJson(_URL)
    .then(function (res) {
      callback(false, res);
    })
    .catch(function (error) {
      callback(true, isJson(error) ? error.toJSON() : error );
    });

  } else {

    const TOKEN = global.token;
    const METHOD = API[api.url].method;
    let _URL = API[api.url].api;

    switch (METHOD) {
      case 'GET':  // 讀取 帶參數
        if(api.req !== null) {
          // _URL = `${_URL}?${JSON.stringify(api.req)}`;
        }
        break;
      case 'PUT':  // 更新 帶id
        if(api.id) {
          _URL = `${_URL}/${api.id}`;
        } else {
          _URL = `${_URL}`;
        }
        break;
      case 'DELETE':  // 刪除 帶id
        _URL = `${_URL}/${api.id}`;
        break;
      case 'PATCH':  // 部分更新（狀態 use、顯示 show） 帶id
        _URL = `${_URL}/${api.id}`;
        break;
      default:  // POST 新增
        break;
    }

    console.log('↓↓================');
    console.log(`%ccall api [${API[api.url].api}]`, 'color: #3faaf4; font-weight: bold;');
    console.log('method：', API[api.url].method);
    console.log('url：', _URL);
    console.log('req：', api.req);
    console.log('id：', api.id);
    console.log('baseURL', API[api.url].baseURL);
    console.log('TOKEN：', TOKEN);
    console.log('↑↑================');

    // 標籤名稱 Authorization
    const headers = {
      'Content-Type': api.url === 'TRAVEL_DETAIL' || api.url === 'ORDER_FORM_CUSTOM'
        ? 'application/json'
        : 'application/x-www-form-urlencoded',
      // 'Authorization': `Bearer ${TOKEN}`
    }

    axios({
      url: _URL,
      data: api.url === 'TRAVEL_DETAIL' || api.url === 'ORDER_FORM_CUSTOM' ? api.req : null,  // POST 用 data
      params: api.url === 'TRAVEL_DETAIL' || api.url === 'ORDER_FORM_CUSTOM' ? null : api.req, // GET 用 params
      method: API[api.url].method,
      responseType: 'json',
      baseURL: baseURL ? baseURL : API[api.url].baseURL || global.api,
      headers: headers
    })
    .then(function (res) {
      if(res) {
        callback(false, res);  // (error: true or false, res)
      } else {
        callback(true, null);  // (error: true or false, res)
      }
    })
    .catch(function (error) {
      callback(true, isJson(error) ? error.toJSON() : error );
    });

  }

}


/** load public json */
export const LoadJson = (file) => {

  console.log('LoadJson [ ' + file + ' ]');

  let today = new Date();
  let now = today.getTime();

  const ajax = fetch(`${file}?${now}`, {
    headers : {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
     }
  })
  .then(function(res){
    return res.json();
  })

  return ajax
}